<div class="main">
  <!-- <ng-container class="" *ngIf="isLoading">
    <div class="loaderLoding">
      <img src="../assets/belairtrip_assets/svg_icon/belairloader.gif" alt="Belairtrip.com" class="img-fluid">
    </div>
  </ng-container> -->
  <!-- <app-header></app-header> -->
  <router-outlet></router-outlet>
  <!-- <app-footer></app-footer> -->
</div>
